// //stateview/filter.js

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import Select from 'react-select'; // ✅ Add react-select
// import './AchievementTable.css';
// import './FilterBar.css';

// const FilterBar = ({ onFilter }) => {
//   const [filters, setFilters] = useState([]);
//   const [selectedProject, setSelectedProject] = useState(null);  
//   const [selectedPid, setSelectedPid] = useState(null);

//   useEffect(() => {
//     axios.get('http://localhost:3006/api/opsco-filters')
//       .then(response => {
//         setFilters(response.data);
  
//         const savedPid = localStorage.getItem("selectedPid");
//         if (savedPid) {
//           const matched = response.data.find(f => f.pId === savedPid);
//           if (matched) {
//             setSelectedPid({ label: savedPid, value: savedPid });
//             setSelectedProject({ label: matched.projectName, value: matched.projectName });
//           }
//         }
//       })
//       .catch(error => console.error('Error fetching filters:', error));
//   }, []);
  
//   const handleFilter = () => {
//     localStorage.setItem("selectedPid", selectedPid?.value || "");
//     localStorage.setItem("selectedProject", selectedProject?.value || "");
//     onFilter({ projectName: selectedProject?.value || '', pId: selectedPid?.value || '' });
//   };
  

//   const handleClear = () => {
//     localStorage.removeItem("selectedPid");
//     localStorage.removeItem("selectedProject");
//     setSelectedProject(null);
//     setSelectedPid(null);
//     onFilter({ projectName: '', pId: '' });
//   };
  

//   const handleProjectChange = (option) => {
//     setSelectedProject(option);
//     const matched = filters.find(item => item.projectName === option?.value);
//     if (matched) {
//       setSelectedPid({ label: matched.pId, value: matched.pId });
//     } else {
//       setSelectedPid(null);
//     }
//   };

//   const handlePidChange = (option) => {
//     setSelectedPid(option);
//     const matched = filters.find(item => item.pId === option?.value);
//     if (matched) {
//       setSelectedProject({ label: matched.projectName, value: matched.projectName });
//     } else {
//       setSelectedProject(null);
//     }
//   };

//   const projectOptions = [...filters]
//   .sort((a, b) => a.projectName.localeCompare(b.projectName))
//   .map(item => ({
//     value: item.projectName,
//     label: item.projectName
//   }));

// const pidOptions = [...filters]
//   .sort((a, b) => a.pId.localeCompare(b.pId))
//   .map(item => ({
//     value: item.pId,
//     label: item.pId
//   }));


//   return (
//     <div className="filter-bar-container1">
//       <div className="filter-bar-box1">
//         <div className="filter-controls">
//           <div className="filter-group">
//             <label htmlFor="projectName">Project Name:</label>
//             <Select
//               id="projectName"
//               value={selectedProject} 
//               onChange={handleProjectChange}
//               options={projectOptions}
//               placeholder="Select Project Name"              
//               classNamePrefix="react-select"
//             />
//           </div>

//           <div className="filter-group">
//             <label htmlFor="projectId">Project ID:</label>
//             <Select
//               id="projectId"
//               value={selectedPid} 
//               onChange={handlePidChange}
//               options={pidOptions}
//               placeholder="Select Project ID"              
//               classNamePrefix="react-select"
//             />
//           </div>

//           <button onClick={handleFilter} className="apply-filter-btn">Apply Filter</button>
//           <button onClick={handleClear} className="clear-filter-btn">Clear Filter</button>
//         </div>

//         <p className="filter-info-text">* Select the filter to view below data</p>
//       </div>
//     </div>
//   );
// };

// export default FilterBar;
//stateview/filter.js

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Select from 'react-select'; // ✅ Add react-select
import './AchievementTable.css';
import './FilterBar.css';

const FilterBar = ({ onFilter }) => {
  const [filters, setFilters] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);  
  const [selectedPid, setSelectedPid] = useState(null);

  useEffect(() => {
    axios.get('https://api-usersreport-insights.haqdarshak.com/api/opsco-filters')
      .then(response => {
        setFilters(response.data);
  
        const savedPid = localStorage.getItem("selectedPid");
        if (savedPid) {
          const matched = response.data.find(f => f.pId === savedPid);
          if (matched) {
            setSelectedPid({ label: savedPid, value: savedPid });
            setSelectedProject({ label: matched.projectName, value: matched.projectName });
          }
        }
      })
      .catch(error => console.error('Error fetching filters:', error));
  }, []);
  
  const handleFilter = () => {
    localStorage.setItem("selectedPid", selectedPid?.value || "");
    localStorage.setItem("selectedProject", selectedProject?.value || "");
    onFilter({ projectName: selectedProject?.value || '', pId: selectedPid?.value || '' });
  };
  

  const handleClear = () => {
    localStorage.removeItem("selectedPid");
    localStorage.removeItem("selectedProject");
    setSelectedProject(null);
    setSelectedPid(null);
    onFilter({ projectName: '', pId: '' });
  };
  

  const handleProjectChange = (option) => {
    setSelectedProject(option);
    const matched = filters.find(item => item.projectName === option?.value);
    if (matched) {
      setSelectedPid({ label: matched.pId, value: matched.pId });
    } else {
      setSelectedPid(null);
    }
  };

  const handlePidChange = (option) => {
    setSelectedPid(option);
    const matched = filters.find(item => item.pId === option?.value);
    if (matched) {
      setSelectedProject({ label: matched.projectName, value: matched.projectName });
    } else {
      setSelectedProject(null);
    }
  };

  // const projectOptions = [...filters]
  // .sort((a, b) => (a.projectName || '').localeCompare(b.projectName || ''))

  // .map(item => ({
  //   value: item.projectName,
  //   label: item.projectName
  // }));
  const projectOptions = filters
  .filter(item => item.projectName && item.projectName.trim() !== '')
  .sort((a, b) => a.projectName.localeCompare(b.projectName))
  .map(item => ({
    value: item.projectName,
    label: item.projectName
  }));

const pidOptions = [...filters]
.sort((a, b) => (a.pId || '').localeCompare(b.pId || ''))

  .map(item => ({
    value: item.pId,
    label: item.pId
  }));


  return (
    <div className="filter-bar-container1">
      <div className="filter-bar-box1">
        <div className="filter-controls">
          <div className="filter-group">
            <label htmlFor="projectName">Project Name:</label>
            <Select
              id="projectName"
              value={selectedProject} 
              onChange={handleProjectChange}
              options={projectOptions}
              placeholder="Select Project Name"              
              classNamePrefix="react-select"
            />
          </div>

          <div className="filter-group">
            <label htmlFor="projectId">Project ID:</label>
            <Select
              id="projectId"
              value={selectedPid} 
              onChange={handlePidChange}
              options={pidOptions}
              placeholder="Select Project ID"              
              classNamePrefix="react-select"
            />
          </div>

          <button onClick={handleFilter} className="apply-filter-btn">Apply Filter</button>
          <button onClick={handleClear} className="clear-filter-btn">Clear Filter</button>
        </div>

        <p className="filter-info-text">* Select the filter to view below data</p>
        <p style={{ marginTop: "-10px", fontSize: "14px", color: "gray" }}>
        📌 This data is from starting of project (Project-level data).
      </p>
      
      </div>
    </div>
  );
};

export default FilterBar;
